module.exports = __webpack_public_path__ + "img/android.db89accc.svg";